<div class="card shadow border-0 mb-3 tab-pane fade fade-in-zoom active show" role="tabpanel">
  <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex align-items-center justify-content-between">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-gear me-2 text-primary"></i>Behavior config</h2>
    @if (hasRoles(['ROLE_API_SITE_WRITE']) | async) {
      <button class="btn btn-primary fw-bold" (click)="createRule()">Add configuration</button>
    }
  </div>
  <div class="card-body">
    @for (siteConfigRule of siteConfigRules; track siteConfigRule) {
      <div class="card card-body border-0 shadow mb-3">
        <app-site-config-element [siteConfigRule]="siteConfigRule" (updated)="refresh()" (deleted)="refresh()"></app-site-config-element>
      </div>
    }
  </div>
</div>
